module.exports = __webpack_public_path__ + "img/skuphone.8a9ae203.png";